import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useFaqs } from "@/lib/queries";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function FaqSection({ faqs: faqsProp, title = "Sık Sorulan Sorular", overline = "Merak Edilenler", number = "07" }) {
  const { data } = useFaqs();
  const faqs = faqsProp || data || [];
  if (!faqs.length) return null;

  return (
    <section data-testid="faq-section" className="obsidian py-24 sm:py-32">
      <div className="container-x grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal>
          <SectionHeading number={number} overline={overline} title={title} subtitle="Aklınıza takılanlar için en sık sorulanları derledik. Daha fazlası için bize ulaşabilirsiniz." />
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full border-t border-white/10">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
                <AccordionTrigger className="py-5 text-left font-display text-base font-medium text-white hover:text-gold hover:no-underline [&[data-state=open]]:text-gold">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-neutral-400">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
